import React, { useState, useEffect } from 'react'
import AliceCarousel from 'react-alice-carousel';
import GenericIcon from 'components/GenericIcon'
import 'react-alice-carousel/lib/alice-carousel.css';

const AwardBadges = ({ header }) => {
  const [isDesktop, setIsDesktop] = useState(true);
  const responsive = {
    0: { items: 3 },
    568: { items: 3 },
    1024: { items: 5 },
  };

  const resize = () => {
    const displayDesktopVersion = window.innerWidth > 576 ? true : false;
    setIsDesktop(displayDesktopVersion)
  }

  useEffect(() => {
    window.addEventListener("resize", resize);
    resize();

    return () => window.removeEventListener("resize", resize);
  }, [])

  const items = [
    <a href="https://www.ratecity.com.au/awards">
      <img className='d-block w-100 carousel-img-bigger' src={gon.assets.rateCityVar2022} alt='carousel-img'/>
    </a>,
    <a href="https://www.ratecity.com.au/awards">
      <img className='d-block w-100 carousel-img-bigger' src={gon.assets.rateCityInv2022} alt='carousel-img'/>
      <div></div>
    </a>,
    <a href="">
      <img className='d-block w-100 carousel-img-smaller' src={gon.assets.mozo2022} alt='carousel-img'/>
    </a>,
    <a href="">
      <img className='d-block w-100 carousel-img' src={gon.assets.mozo2021} alt='carousel-img'/>
    </a>,
    <a href="https://www.ratecity.com.au/awards">
      <img className='d-block w-100 carousel-img' src={gon.assets.rateCityVar2021} alt='carousel-img'/>
    </a>,
    <a href="https://www.ratecity.com.au/awards">
      <img className='d-block w-100 carousel-img' src={gon.assets.rateCityRef2021} alt='carousel-img'/>
    </a>,
    <a href="https://www.finder.com.au/finderawards">
      <img className='d-block w-100 carousel-img' src={gon.assets.finderWinner} alt='carousel-img'/>
    </a>,
    <a href="https://www.finder.com.au/finderawards">
      <img className='d-block w-100 carousel-img' src={gon.assets.finderFinalist} alt='carousel-img'/>
    </a>,
  ];

  const leftButton = <button className='left-btn'><GenericIcon className='generic-icon' name='leftArrow' /></button>;
  const rightButton = <button className='right-btn'><GenericIcon className='generic-icon' name='rightArrow' /></button>;

  return (
    <div className='loan-preferences' id='loan-preferences'>
      {header}
      <AliceCarousel 
        infinite={true}
        disableDotsControls={isDesktop}
        responsive={responsive}
        items={items} 
        renderPrevButton={() => {
          return isDesktop ? leftButton : null;
        }}
        renderNextButton={() => {
          return isDesktop ? rightButton : null;
        }}
      />
    </div>
  );
};


export default AwardBadges;
